import React from "react";
import { useMobileHeaderContext } from "@/components/layout/use-mobile-header-context";
import { useBreadcrumb } from "../providers/BreadcrumbProvider";
import { Breadcrumb } from "./Breadcrumb";

/**
 * Mobilde header'ın hemen altında tam genişlik breadcrumb şeridi.
 *
 * Header'ın sağ slotu logo ortada olduğu için ~160px'ti; üç seviyeli bir
 * zincir orada "Alış… > Ürün…" diye kırpılıyordu. Şerit header'ı `h-14`
 * bırakır (mobil sidebar drawer `top-14`'e bağlı), yalnızca "other"
 * bağlamında ve gösterilecek en az bir seviye varsa render olur.
 */
export const MobileBreadcrumbBar: React.FC = () => {
  const { mobileContext } = useMobileHeaderContext();
  const { showBreadcrumb } = useBreadcrumb();

  if (mobileContext !== "other" || !showBreadcrumb) return null;

  return (
    <div className="md:hidden shrink-0 w-full border-b border-border-secondary/70 dark:border-gray-800 bg-bg-primary dark:bg-gray-900 px-3 py-1.5">
      <Breadcrumb />
    </div>
  );
};

export default MobileBreadcrumbBar;
